import wrapRoot from './src/root/wrapRootElement';
import wrapPage from './src/root/wrapPageElement';

export const wrapRootElement = wrapRoot;
export const wrapPageElement = wrapPage;
